/* eslint-disable react/no-unused-prop-types */
import React from "react";
import PropTypes from "prop-types";

import "./sidenav.scss";
import SidenavUtils from "../../lib/sidenavUtils";
import { gatherClasses } from "../../lib/utils";

const SideNav = props => {
  const { dataTestId } = props;
  const sidenavUtils = new SidenavUtils();

  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(props, "oui-sidenav-container")}
    >
      {sidenavUtils.renderSideNav(props)}
    </div>
  );
};

SideNav.propTypes = {
  items: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

SideNav.defaultProps = {
  onItemClick: () => {},
  dataTestId: "orion-sidenav"
};

SideNav.displayName = "OrionSideNav";

export default SideNav;
